import { Skeleton, StockGauge, formatNumber } from '@platform/design-system';
import type { ReactNode } from 'react';
import type { StockCell } from './useProductList.ts';
import { usePageContext } from '../../usePageContext.ts';
import styles from './ProductList.module.css';

export const StockCellView = ({ cell, addition }: { cell: StockCell; addition?: ReactNode }) => {
  const { t, locale } = usePageContext();
  if (cell === 'loading') return <Skeleton width="48px" />;
  if (cell === 'failed') return <span title={t('productList.stockUnavailable')}>—</span>;
  return (
    <span className={styles['stock']}>
      <span className={styles['health']}>
        <StockGauge health={cell.health} available={cell.available} />
        <span className={styles['quantity']}>{formatNumber(cell.available, locale)}</span>
        {addition}
      </span>
      {cell.health === 'ok' ? null : (
        <span className={[styles['stockNote'], styles[cell.health]].join(' ')}>
          {t(`stockMatrix.${cell.health}`)}
        </span>
      )}
    </span>
  );
};
